export default __webpack_public_path__ + "i18n/translation.dcdc3f37.json";